import {
  SuspendedMultichoiceButtonControl,
  SuspendedMultichoiceCheckboxControl,
  SuspendedMultichoiceImageButtonControl
} from '../suspended'
import type { MultichoiceControlComponentProps } from '../types'

export const MultichoiceControl = (props: MultichoiceControlComponentProps) => {
  switch (props.uiType) {
    case 'checkbox':
      return <SuspendedMultichoiceCheckboxControl {...(props as any)} />
    case 'imageButton':
      return <SuspendedMultichoiceImageButtonControl {...(props as any)} />
    default:
      return <SuspendedMultichoiceButtonControl {...(props as any)} />
  }
}
